<template>
  <a-row type='flex'
         class="item">
    <a-col :span="2">
      <auto-icon :type='item.widgetSettings.icon' />
    </a-col>
    <a-col :span="8">
      <a-row class="title">
        {{ item.name }}
      </a-row>
      <a-row class="hint">
        {{ item.desc }}
      </a-row>
    </a-col>
    <a-col :span="10">
      <raw-avatar :img='image'
                  :uploadImg='onUpload'
                  v-bind="item.widgetSettings"
                  showUpload />
    </a-col>
  </a-row>
</template>

<script setup lang="ts">
/* eslint-disable @typescript-eslint/no-explicit-any */
import { toUrl } from '@/utils'
import { AutoIcon, RawAvatar } from '@iota-cn/ui-components'
import { container } from 'tsyringe'
import { computed } from 'vue'
import { CORE_AXIOS, Http } from '../../../../../core'
import { useSysConfig } from '../../DefaultSystemPlugin'

const axios = container.resolve<Http>(CORE_AXIOS)

const sysConfig = useSysConfig()

const props = defineProps(['item'])
const onUpload = (imgObj: any) => {
  const uploadFn = (blob: any) => {
    const fd = new FormData()
    let uploaded: string
    fd.append("fileBlob", blob, `${props.item.key}.png`) //目前后端做的验证必须加后缀
    axios.post('/v1/api/attachment/sysconfig', fd)
      .then((res: any) => {
        uploaded = res.uploaded
        return sysConfig.updateSysconfig({ key: props.item.key, value: uploaded })
      }).catch(() => {
        return
      })
  }
  if (typeof imgObj.toBlob === 'function') {
    imgObj.toBlob(uploadFn)
  }
  else {
    const blob = imgObj
    uploadFn(blob)
  }
}

const image = computed(() => {
  let value = props.item.value || props.item.defaultValue
  value = toUrl(value)
  return value
})
</script>

<style>
</style>